import WithStripedShadow from 'components/hoc/WithStripedShadow';
import DisclaimerButton from 'components/pages/placeholders/shared/DisclaimerButton';
import type { HTMLAttributes } from 'react';
import styled from 'styled-components';
import type { TypePositionDetailed, TypeImageBannerFields, TypeImageBannerDetailed } from 'types/autogen/contentful';
import Text from '../Text';
import type { ExtractSymbol } from '../../shared/types';
import ComponentRenderer from '../../shared/ComponentRenderer';

// #region Styles
const Wrapper = styled.div`
    position: relative;
`;

const WrapperWithStripedShadow = styled(WithStripedShadow(Wrapper))`
    display: flex;
`;

const PositionContainer = styled.div`
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
`;
// #endregion Styles

type ImageWrapperProps = {
    id: string;
    dialog?: {
        buttonText: NonNullable<TypeImageBannerDetailed['fields']['buttonText']>;
        quickviewContent: NonNullable<TypeImageBannerDetailed['fields']['quickviewContent']>;
        buttonPosition: NonNullable<TypeImageBannerDetailed['fields']['buttonPosition']>;
    };
    theme?: ExtractSymbol<TypeImageBannerFields['theme']>;
    textOnImage?: TypePositionDetailed;
} & HTMLAttributes<HTMLDivElement>;

function Content(props: Pick<ImageWrapperProps, 'textOnImage' | 'dialog' | 'id' | 'children'>) {
    const { textOnImage, dialog, id, children } = props;
    return (
        <>
            {children}
            {textOnImage && (
                <PositionContainer>
                    <ComponentRenderer {...textOnImage} />
                </PositionContainer>
            )}
            {dialog && (
                <DisclaimerButton
                    disclaimerText={<Text {...dialog.quickviewContent} />}
                    buttonText={dialog.buttonText}
                    quickViewId={id}
                    buttonLocation={dialog.buttonPosition}
                />
            )}
        </>
    );
}

export default function ImageWrapper(props: ImageWrapperProps) {
    const { theme, dialog, textOnImage, id, children, ...restProps } = props;
    const contentProps = { dialog, textOnImage, id, children };

    if (theme === 'Stripes') {
        // TODO: designThemeName transparentSecondColor
        return (
            <WrapperWithStripedShadow designThemeName="club1" transparentSecondColor={false} {...restProps}>
                <Content {...contentProps} />
            </WrapperWithStripedShadow>
        );
    }

    return (
        <Wrapper {...restProps}>
            <Content {...contentProps} />
        </Wrapper>
    );
}
